import axios from 'axios';
import { getDefaultAxiosConfig } from 'services/service-defaults';
import { baseUrlConfig, getAuthenticityTokenUrl } from 'services/service-urls';

export const getAuthenticityToken = async (baseUrl: string = baseUrlConfig): Promise<string> => {
  const res = await axios.get(getAuthenticityTokenUrl(baseUrl), getDefaultAxiosConfig());
  const { content: token } = res.data.csrf_token;
  return token;
};
